module.exports = __webpack_public_path__ + "question@2x.fd5ef0a6f7b10a088706560c130d103e.png";